@if (currentSnack !== null) {
  <div
    animate.enter="enter-animation"
    animate.leave="leave-animation"
    class="fixed top-4 flex flex-col items-center justify-center w-full z-[9999] pointer-events-none origin-top"
  >
    <div
      [ngClass]="{
        'justify-center px-4': !currentSnack.customTrailingIcon,
        'justify-between pl-4 pr-3': currentSnack.customTrailingIcon,
      }"
      class="flex flex-row items-center gap-2 min-h-12 max-h-20 min-w-64 rounded-md bg-gray-700 shadow-lg text-white dark:bg-violet-50 dark:text-zinc-800"
    >
      <div class="text-sm font-normal text-nowrap text-center">
        {{ currentSnack.message }}
      </div>
      @if (currentSnack.customTrailingIcon) {
        <ng-container
          [ngTemplateOutlet]="currentSnack.customTrailingIcon"
        ></ng-container>
      }
    </div>
  </div>
}
